import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyARep79dZbjnJphwNb6sSqnjxLxhd33vmg",
    authDomain: "crigotech.firebaseapp.com",
    projectId: "crigotech",
    storageBucket: "crigotech.firebasestorage.app",
    messagingSenderId: "998329150433",
    appId: "1:998329150433:web:630ef3e2fa5eee3cd700a0",
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };